<script lang="ts" setup>
interface ChipInfo {
  icon: string;
  label: string;
}

const props = defineProps<{
  chip?: ChipInfo;
  message: string;
  square?: boolean;
}>();

export type { ChipInfo };
</script>

<template>
  <div
    class="restaurant-info py-1 text-white"
    :class="{ 'restaurant-info--square': props.square }"
    flat
  >
    <UContainer :class="{ 'justify-center': props.square }">
      <UIcon
        class="text-rose-500 text-3xl"
        name="ic:round-error-outline"
      />

      <span data-test="message">
        {{ props.message }}
      </span>

      <div
        v-if="props.chip"
        class="restaurant-info__chip text-sm text-teal-500 bg-gray-300"
        data-test="chip"
      >
        <UIcon
          class="text-xl"
          :name="props.chip.icon"
          data-test="icon"
          dynamic
        />

        <span
          class="font-semibold"
          data-test="label"
        >
          {{ props.chip.label }}
        </span>
      </div>
    </UContainer>
  </div>
</template>

<style lang="scss" scoped>
.restaurant-info {
  background-color: #000000b3;
  border-radius: 0.5rem;

  &>div {
    padding: 0.5rem 1.5rem;
    display: flex;
    column-gap: 0.5rem;
    align-items: center;
    flex-wrap: wrap;
    white-space: nowrap;

    &>.restaurant-info__chip {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      padding: 0.15rem 0.5rem;
      border-radius: 1rem;
      font-weight: 600;
      border: 1px solid currentColor;
    }
  }

  &--square {
    border-radius: 0;
  }
}
</style>
